import React from 'react';
import './Skills.css';
import { GiSwordWound, GiMagicSwirl, GiWingedSword, GiSpellBook } from 'react-icons/gi';
import { MdOutlineAutoAwesome, MdOutlinePsychology } from 'react-icons/md';

function Skills() {
  return (
    <div className="skills-screen">
      {/* Hero Section */}
      <div className="container-fluid py-5 d-flex align-items-center min-vh-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="content-wrapper">
                <h1 className="font-big slide-in-top">
                  Divine <span className="animate-charcter">Powers</span>
                </h1>
                <div className="gold-bar mb-4 slide-in-bottom"></div>
                <p className="lead-text slide-in-bottom">
                  As a Norse God of Mischief and Mayhem, Kara wields powers that blend divine might with cunning trickery.
                  Her abilities have been honed over millennia, making her a formidable force in any realm.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Combat Skills */}
      <div className="container-fluid skills-section py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5 slide-in-bottom">Combat Mastery</h2>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="skill-card slide-in-bottom">
                <GiSwordWound className="skill-icon" />
                <h3>Weapon Expertise</h3>
                <p>Master of twin daggers forged from celestial metal. Her combat style combines precision with unpredictable movements.</p>
                <div className="skill-level">
                  <div className="progress">
                    <div className="progress-bar" style={{width: '95%'}}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="skill-card slide-in-bottom">
                <GiWingedSword className="skill-icon" />
                <h3>Battle Tactics</h3>
                <p>Strategic mind honed through countless battles. Expert in turning chaos into victory.</p>
                <div className="skill-level">
                  <div className="progress">
                    <div className="progress-bar" style={{width: '90%'}}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="skill-card slide-in-bottom">
                <MdOutlinePsychology className="skill-icon" />
                <h3>Psychological Warfare</h3>
                <p>Master manipulator who uses wit and charm to outmaneuver opponents before the first strike.</p>
                <div className="skill-level">
                  <div className="progress">
                    <div className="progress-bar" style={{width: '98%'}}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Magical Abilities */}
      <div className="container-fluid abilities-section py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5 slide-in-bottom">Divine Powers</h2>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="ability-card slide-in-bottom">
                <GiMagicSwirl className="ability-icon" />
                <h3>Reality Manipulation</h3>
                <p>Can bend the fabric of reality to her will, creating illusions and altering perceptions.</p>
                <ul className="ability-list">
                  <li>Dimensional Shifting</li>
                  <li>Illusion Crafting</li>
                  <li>Reality Warping</li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="ability-card slide-in-bottom">
                <GiSpellBook className="ability-icon" />
                <h3>Ancient Magic</h3>
                <p>Access to forgotten spells and rituals from the dawn of Norse mythology.</p>
                <ul className="ability-list">
                  <li>Elemental Control</li>
                  <li>Time Manipulation</li>
                  <li>Divine Blessings</li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="ability-card slide-in-bottom">
                <MdOutlineAutoAwesome className="ability-icon" />
                <h3>Divine Presence</h3>
                <p>Innate abilities granted by her status as a Norse God.</p>
                <ul className="ability-list">
                  <li>Immortality</li>
                  <li>Superhuman Strength</li>
                  <li>Divine Aura</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Special Traits */}
      <div className="container-fluid traits-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <h2 className="mb-4 slide-in-bottom">Unique Traits</h2>
              <div className="traits-grid">
                <div className="trait-item slide-in-bottom">
                  <h4>Scar of Wisdom</h4>
                  <p>The scar over her left eye grants enhanced perception and insight into the true nature of things.</p>
                </div>
                <div className="trait-item slide-in-bottom">
                  <h4>Silver Hair</h4>
                  <p>Her silver hair, once red, symbolizes her transformation and growth through the ages.</p>
                </div>
                <div className="trait-item slide-in-bottom">
                  <h4>Ruby Eyes</h4>
                  <p>Her ruby-red eyes can see through deception and into the hearts of mortals and gods alike.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;